// Styles
require("./normalize.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/webstrap/normalize/index.js
 ** module id = 13
 ** module chunks = 0 1
 **/